import { render, staticRenderFns } from "./UpgradeProfile.vue?vue&type=template&id=7ee47633"
import script from "./UpgradeProfile.vue?vue&type=script&lang=js"
export * from "./UpgradeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports